export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()
  const api    = useApi()

  const feVersion = (config.public.appVersion as string) || 'dev'

  let beCommit  = '…'
  let beBuiltAt = ''
  try {
    const { data } = await api.get('/auth/version')
    beCommit  = data?.data?.commit  ?? 'unknown'
    beBuiltAt = data?.data?.built_at ?? ''
  } catch {
    beCommit = 'offline'
  }

  const beLabel = beBuiltAt
    ? `${beCommit} · ${new Date(beBuiltAt).toLocaleString('pt-BR')}`
    : beCommit

  console.groupCollapsed(
    `%c AevixSaude %c FE ${feVersion} · BE ${beCommit} `,
    'background:#4f46e5;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:700',
    'background:#1e1b4b;color:#a5b4fc;padding:2px 6px;border-radius:0 3px 3px 0;font-size:11px',
  )
  console.log('%cFrontend', 'font-weight:600;color:#6366f1', `v${feVersion}`)
  console.log('%cBackend ', 'font-weight:600;color:#6366f1', beLabel)
  console.log('%cAPI     ', 'font-weight:600;color:#6366f1', config.public.apiBase)
  console.groupEnd()
})
